<script>
  import { setContext } from 'svelte'
  import PortfolioScreen from '../../../module_core/module_portfolio/screen/portfolio/PortfolioScreen.svelte'

  const { data } = $props()

  setContext('portfolio_page', data)
</script>

<svelte:head>
  <title>{data.metadata.title || ''}</title>

  <meta title="description" content={data.metadata.description || ''} />
</svelte:head>

<PortfolioScreen />
